import { useState, useEffect } from 'react';
import { companyCheckSetup, CompanySetupResponse } from '../api/company';

export const useCompanySetup = () => {
    const [hasCompany, setHasCompany] = useState<boolean | null>(null);
    const [company, setCompany] = useState<CompanySetupResponse['company'] | null>(null);
    const [loading, setLoading] = useState(true);
    const [showSetupDialog, setShowSetupDialog] = useState(false);

    const checkCompanySetup = async () => {
        try {
            setLoading(true);
            const response = await companyCheckSetup();
            setHasCompany(response.has_company);
            setCompany(response.company || null);

            // Show setup dialog if user doesn't have a company
            if (!response.has_company) {
                setShowSetupDialog(true);
            }
        } catch (error) {
            console.error('Error checking company setup:', error);
            // If there's an error, assume no company to be safe
            setHasCompany(false);
            setShowSetupDialog(true);
        } finally {
            setLoading(false);
        }
    };

    const onCompanyCreated = () => {
        setHasCompany(true);
        setShowSetupDialog(false);
        // Refresh company data
        checkCompanySetup();
    };

    useEffect(() => {
        checkCompanySetup();
    }, []);

    return {
        hasCompany,
        company,
        loading,
        showSetupDialog,
        setShowSetupDialog,
        onCompanyCreated,
        refreshCompanySetup: checkCompanySetup
    };
}; 